import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import SiteHeader from '@/components/kb/site-header'
import SiteFooter from '@/components/kb/site-footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a href='#main' className='sr-only z-[70] rounded-md border-2 border-foreground bg-primary px-3 py-2 font-bold focus:not-sr-only focus:fixed focus:left-3 focus:top-3'>
                Skip to content
            </a>

            <SiteHeader />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
